// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import NewZealand from '../_raw/flag/icon_flag_new_zealand.png';

export default () => <img src={NewZealand} alt="NewZealand" />;
